(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;
  const SELECTORS = '.adam-cards__card, .adam-gallery__media, .adam-services__card';
  const MAX_DEG = 7;

  function bind(el) {
    if (el.dataset.adamsTilt) return;
    el.dataset.adamsTilt = '1';
    el.classList.add('adams-tilt');
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width;
      const py = (e.clientY - r.top) / r.height;
      const rx = (0.5 - py) * MAX_DEG * 2;
      const ry = (px - 0.5) * MAX_DEG * 2;
      el.style.setProperty('--tilt-x', rx.toFixed(2) + 'deg');
      el.style.setProperty('--tilt-y', ry.toFixed(2) + 'deg');
    });
    el.addEventListener('pointerleave', () => {
      el.style.setProperty('--tilt-x', '0deg');
      el.style.setProperty('--tilt-y', '0deg');
    });
  }

  function scan() {
    document.querySelectorAll(SELECTORS).forEach(bind);
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
